import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { createElement } from "@emotion/react";
import { styled } from "@mui/material";
import { ProfileQuestionnaireItem } from "./components/profile-questionnaire-item.es.js";
import { ProfileQuestionnaireStatus } from "./enums/profile-questionnaire-status.enum.es.js";
import Stack from "../../../node_modules/@mui/material/Stack/Stack.es.js";
import { BorderRadius } from "../../foundations/border-radius.es.js";
import { Border } from "../../foundations/palette.es.js";
const ProfileQuestionnaireStack = styled(Stack)({
  borderRadius: BorderRadius.brand,
  border: `1px solid ${Border.main}`,
  overflow: "hidden"
});
function ProfileQuestionnaire({
  sections,
  id,
  ...rest
}) {
  return /* @__PURE__ */ jsx(ProfileQuestionnaireStack, { id, children: sections.map(function mapSection(section, index) {
    const sectionNumber = index + 1;
    const shouldShowLinearProgress = section.status === ProfileQuestionnaireStatus.Completing && section.percentage > 0;
    const shouldShowBottomDivider = index + 1 !== sections.length;
    return /* @__PURE__ */ createElement(ProfileQuestionnaireItem, { ...section, ...rest, key: section.id, sectionNumber, withLinearProgress: shouldShowLinearProgress, withBottomDivider: shouldShowBottomDivider });
  }) });
}
export {
  ProfileQuestionnaire
};
//# sourceMappingURL=profile-questionnaire.es.js.map
